import { Component, Input, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MenuSection, MenuService } from './app.menu.service';
import { AppMainComponent } from '../app.main.component';
import { AppComponent } from '../app.component';

@Component({
	/* eslint-disable @angular-eslint/component-selector */
	selector: '[app-menuitem]',
	/* eslint-enable @angular-eslint/component-selector */
	templateUrl: './app.menuitem.component.html',
	styleUrls: ['./app.menuitem.component.scss'],
	// eslint-disable-next-line @angular-eslint/no-host-metadata-property
	host: {
		'[class.layout-root-menuitem]': 'root',
		'[class.active-menuitem]': '(active && !root) || (active && appMain.isSlim())',
	},
	animations: [
		trigger('children', [
			state(
				'void',
				style({
					height: '0px',
				}),
			),
			state(
				'hiddenAnimated',
				style({
					height: '0px',
				}),
			),
			state(
				'visibleAnimated',
				style({
					height: '*',
				}),
			),
			transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
			transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
			transition(
				'void => visibleAnimated, visibleAnimated => void',
				animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'),
			),
		]),
	],
})
export class AppMenuitemComponent implements OnInit, OnDestroy {
	@Input() item: MenuSection;

	@Input() index: number;

	@Input() root: boolean;

	@Input() parentKey: string;

	active = false;

	menuSourceSubscription: Subscription;

	menuResetSubscription: Subscription;

	key: string;

	constructor(
		public appMain: AppMainComponent,
		public app: AppComponent,
		public router: Router,
		private cd: ChangeDetectorRef,
		private menuService: MenuService,
	) {
		this.menuSourceSubscription = this.menuService.menuSource$.subscribe((key) => {
			// deactivate current active menu
			if (this.active && this.key !== key && key.indexOf(this.key) !== 0) {
				this.active = false;
			}
		});

		this.menuResetSubscription = this.menuService.resetSource$.subscribe(() => {
			this.active = false;
		});

		this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
			if (this.appMain.isSlim()) {
				this.active = false;
			} else {
				if (this.item.routerLink) {
					this.updateActiveStateFromRoute();
				} else {
					this.active = false;
				}
			}
		});
	}

	ngOnInit() {
		if (this.item.translate === undefined) {
			this.item.translate = true;
		}

		if (!this.appMain.isSlim() && this.item.routerLink) {
			this.updateActiveStateFromRoute();
		}

		this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);
	}

	updateActiveStateFromRoute() {
		this.active = this.router.isActive(this.item.routerLink[0], this.item.items ? false : true);
	}

	itemClick(event: Event) {
		// avoid processing disabled items
		if (this.item.disabled) {
			event.preventDefault();
			return;
		}

		// navigate with hover in horizontal mode
		if (this.root) {
			this.appMain.menuHoverActive = !this.appMain.menuHoverActive;
		}

		// notify other items
		this.menuService.onMenuStateChange(this.key);

		// toggle active state
		if (this.item.items) {
			this.active = !this.active;
		} else {
			// activate item
			this.active = true;

			if (this.appMain.isMobile()) {
				this.appMain.staticMenuMobileActive = false;
			}

			// reset slim menu
			if (this.appMain.isSlim()) {
				this.menuService.reset();
				this.appMain.menuHoverActive = false;
			}
		}

		this.removeActiveInk(event);
	}

	removeActiveInk(event: Event) {
		const currentTarget = event.currentTarget as HTMLElement;
		setTimeout(() => {
			if (currentTarget) {
				const activeInk = currentTarget.querySelector('.p-ink-active');
				if (activeInk) {
					if (activeInk.classList) {
						activeInk.classList.remove('p-ink-active');
					} else {
						activeInk.className = activeInk.className.replace(
							new RegExp('(^|\\b)' + 'p-ink-active'.split(' ').join('|') + '(\\b|$)', 'gi'),
							' ',
						);
					}
				}
			}
		}, 401);
	}

	onMouseEnter() {
		// activate item on hover
		if (
			this.root &&
			this.appMain.menuHoverActive &&
			this.appMain.isSlim() &&
			!this.appMain.isMobile() &&
			!this.appMain.isTablet()
		) {
			this.menuService.onMenuStateChange(this.key);
			this.active = true;
		}
	}

	ngOnDestroy() {
		if (this.menuSourceSubscription) {
			this.menuSourceSubscription.unsubscribe();
		}

		if (this.menuResetSubscription) {
			this.menuResetSubscription.unsubscribe();
		}
	}
}
